<template>
  <div id="assign-editor-dialog">
    <ipub-model :title="'Select Editor'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p2 mar-b-12">
        <strong>All</strong>: Current assigned manuscripts (excepted status of Paper Accepted, Rejected, Withdrawn, Online)<br />
        <strong>Pending</strong>: Current assigned manuscripts for status of Pending Review, Revised Version Review
      </div>
      <site-search-group class="mar-b-20"
                         v-model.trim="search"
                         placeholder="Search by Academic Editor’s email or name"
                         @search="getList()"
                         @clear="handleClear" />
      <div class="page-content">
        <ipub-table :columns="columns"
                    border
                    :pagination="false"
                    :dataSource="dataSource">
          <template v-slot:select="{record}">
            <ipub-radio @change="(e)=>{onCheckChange(e, record.id)}"
                        :checked="record.id === params.editorId" />
          </template>
          <template v-slot:roles="{text}">
            {{text.map((item)=>{return item.name}).join(', ')}}
          </template>
          <template v-slot:name="{record}">
            {{record.firstName}} {{record.lastName}}
          </template>
        </ipub-table>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group.vue'
import { editorAssign } from '@/api/editor'

const columns = [
  {
    title: '',
    enTitle: 'Select',
    width: 60,
    dataIndex: 'id',
    slot: 'select'
  },
  {
    title: '',
    enTitle: 'System Role',
    width: 150,
    dataIndex: 'roleList',
    slot: 'roles'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'All',
    width: 100,
    dataIndex: 'allNum',
  },
  {
    title: '',
    enTitle: 'Pending',
    width: 100,
    dataIndex: 'pendingDecisionNum',
  },
]
export default {
  components: { SiteSearchGroup },
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      columns,
      params: {
        editorId: ''
      },
      search: '',
      dataSource: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          editorId: ''
        }
        this.search = ''
        this.dataSource = []
      } else {
        this.params.editorId = this.inputData.editor && this.inputData.editor.id
        this.getList()
      }
    }
  },
  methods: {
    onCheckChange (e, id) {
      if (e) {
        return
      }
      this.params.editorId = id
    },
    async confirm () {
      if (!this.params.editorId) {
        this.$message.error({
          title: 'Error',
          content: 'Please select the person to be assigned to'
        })
        return
      }
      const { id, sign } = this.inputData
      await editorAssign.edit(id, { sign, editorId: this.params.editorId })
      this.$message.success({
        title: 'Success',
        content: 'Assigned successfully'
      })
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
    handleClear () {
      this.search = ''
      this.getList()
    },
    async getList () {
      const { id, sign, journalId } = this.inputData
      this.dataSource = await editorAssign.get({
        manuscriptId: id,
        sign, journalId, search: this.search
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
